import { useRef, useEffect } from "react";
import detectBrowser from "safervpn-storybook/src/tools/detectBrowser";
import { useSelector } from "react-redux";

export function useDriftIdentify() {
  let { data } = useSelector((s) => s.usersMeGet);
  let identified = useRef(false);
  useEffect(() => {
    if (data && window.drift && !identified.current) {
      let { id, email, tenantId, role } = data.user;
      window.drift.identify(id, {
        Email: email,
        tenant: tenantId,
        Role: role?.name,
        OS: detectBrowser?.os,
      });
      identified.current = true;
    }
  }, [data]);

  useEffect(
    () => () => {
      window.drift && window.drift.reset();
    },
    []
  );
}
